import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import type { QuotaWithRelations } from "~/modules/quota/api/quota/quotaTypes.ts";
import UpdateQuotaStatusForm
	from "~/modules/quota/components/QuotaDetailsView/components/UpdateQuotaStatusSidebar/UpdateQuotaStatusForm.tsx";
import { invalidateQuotaQueries } from "~/modules/quota/utils/quotaCacheUtils.ts";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	quota: QuotaWithRelations
};

const UpdateQuotaStatusSidebar = ({
	isOpen,
	onClose,
	quota,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await invalidateQuotaQueries(queryClient);
		onClose();
	}, [onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateQuotaStatusForm onCancel={onClose}
											  onSuccess={handleSuccess}
											  quota={quota} />}
		</Sidebar>
	);
};

export default UpdateQuotaStatusSidebar;
